/*eslint-disable*/

import { API_URLS } from '_constants';
import apiData from '_entities/old/api/config';

const { baseUrl } = apiData;

export const optimizeWithVROOM = async (waypoints) => {
  const validWaypoints = waypoints.filter((wp) => wp.latLng !== null);

  if (validWaypoints.length < 3) {
    throw new Error('Need at least 3 waypoints to optimize');
  }

  try {
    // Convert waypoints to VROOM format
    const vroomPayload = createVroomPayload(validWaypoints);
    const VROOM_API_URL = `${baseUrl}${API_URLS.vroomOptimization}`;

    const response = await fetch(VROOM_API_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Token ${localStorage.getItem('Authorization')}`,
      },
      body: JSON.stringify(vroomPayload),
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`VROOM API error: ${response.status} - ${errorText}`);
    }

    const result = await response.json();

    return processVroomResult(result, validWaypoints);
  } catch (error) {
    console.error('Error optimizing with VROOM:', error);
    throw error;
  }
};

const createVroomPayload = (waypoints, roundTrip) => {
  const start = waypoints[0];
  const startCoords = [start.latLng.lng, start.latLng.lat];

  const end = roundTrip ? start : waypoints[waypoints.length - 1];
  const endCoords = [end.latLng.lng, end.latLng.lat];

  const vehicle = {
    id: 0,
    start: startCoords,
    end: endCoords,
  };

  const jobs = [];

  const startIdx = 1;
  const endIdx = roundTrip ? waypoints.length : waypoints.length - 1;

  for (let i = startIdx; i < endIdx; i++) {
    const waypoint = waypoints[i];
    jobs.push({
      id: i - 1,
      location: [waypoint.latLng.lng, waypoint.latLng.lat],
      description: waypoint.name || `Waypoint ${i}`,
    });
  }

  return {
    vehicles: [vehicle],
    jobs: jobs,
  };
};

const processVroomResult = (vroomResult, originalWaypoints) => {
  if (!vroomResult.routes || vroomResult.routes.length === 0) {
    throw new Error('No routes returned from VROOM');
  }

  const route = vroomResult.routes[0];
  const steps = route.steps;

  const optimizedWaypoints = [];

  steps.forEach((step) => {
    const stepType = step.type;

    if (stepType === 'start') {
      optimizedWaypoints.push(originalWaypoints[0]);
    } else if (stepType === 'job') {
      const jobLocation = step.location;
      const matchingWaypoint = findWaypointByCoordinates(
        originalWaypoints,
        jobLocation[1], // latitude
        jobLocation[0], // longitude
      );

      if (matchingWaypoint) {
        optimizedWaypoints.push(matchingWaypoint);
      }
    } else if (stepType === 'end') {
      const lastWaypoint = originalWaypoints[originalWaypoints.length - 1];
      const lastAddedWaypoint = optimizedWaypoints[optimizedWaypoints.length - 1];

      if (!isSameWaypoint(lastAddedWaypoint, lastWaypoint)) {
        optimizedWaypoints.push(lastWaypoint);
      }
    }
  });

  return optimizedWaypoints;
};

const findWaypointByCoordinates = (waypoints, lat, lng, tolerance = 0.0001) => {
  return waypoints.find((wp) => {
    const latDiff = Math.abs(wp.latLng.lat - lat);
    const lngDiff = Math.abs(wp.latLng.lng - lng);

    return latDiff < tolerance && lngDiff < tolerance;
  });
};

const isSameWaypoint = (wp1, wp2) => {
  if (!wp1 || !wp2) return false;

  return Math.abs(wp1.latLng.lat - wp2.latLng.lat) < 0.0001 && Math.abs(wp1.latLng.lng - wp2.latLng.lng) < 0.0001;
};
